var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "company-list-dialog",
      attrs: { visible: _vm.visible, "close-on-click-modal": false },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        },
        close: _vm.dialogClose
      }
    },
    [
      _c(
        "el-form",
        { attrs: { model: _vm.getCompanyListParam, "label-width": "60px" } },
        [
          _c(
            "el-row",
            { staticClass: "show-dialog-style" },
            [
              _c("el-col", { attrs: { span: 5 } }, [
                _vm._v("\n         \n      ")
              ]),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-select",
                    {
                      on: { change: _vm.onCompanyList },
                      model: {
                        value: _vm.getCompanyListParam.company_type,
                        callback: function($$v) {
                          _vm.$set(_vm.getCompanyListParam, "company_type", $$v)
                        },
                        expression: "getCompanyListParam.company_type"
                      }
                    },
                    _vm._l(_vm.companyTypeList, function(item) {
                      return _c("el-option", {
                        key: item.code_id,
                        attrs: { label: item.name, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入公司名称" },
                    model: {
                      value: _vm.getCompanyListParam.company_name,
                      callback: function($$v) {
                        _vm.$set(_vm.getCompanyListParam, "company_name", $$v)
                      },
                      expression: "getCompanyListParam.company_name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 3 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", id: "headLeftSelect" },
                      on: { click: _vm.searchCompanyList }
                    },
                    [_vm._v("搜索")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticClass: "show-table-style",
          attrs: {
            data: _vm.companyList.list,
            height: "310",
            "highlight-current-row": true
          },
          on: { "row-click": _vm.selectCompany }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "company_name",
              label: "单位名称",
              align: "center",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "addr",
              label: "单位地址",
              align: "center",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "contact_name",
              label: "负责人",
              align: "center",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "contact_phone",
              label: "联系电话",
              align: "center",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "create_date",
              label: "入驻时间",
              align: "center",
              "show-overflow-tooltip": ""
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("el-pagination", {
        staticClass: "list-pagination",
        attrs: {
          id: "pagination",
          "current-page": _vm.getCompanyListParam.page,
          "page-sizes": [10],
          "page-size": _vm.getCompanyListParam.page_size,
          background: "",
          layout: "total,sizes,prev, pager, next, jumper",
          total: _vm.companyList.total_count
        },
        on: { "current-change": _vm.handleCompanyCurrentChange }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { id: "back-style" }, on: { click: _vm.dialogClose } },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", id: "headLeftSelect" },
              on: { click: _vm.confirmChooseCompany }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-241675b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-241675b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CompanySelect/components/CompanyListDialog.vue
// module id = null
// module chunks = 